import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button } from '@mui/material';

import {
  stylesConsentBannerActions,
  stylesConsentBannerContainer,
  stylesConsentBannerHeaderTitle,
} from './ConsentBanner.styles';

export const ConsentBanner: React.FunctionComponent = () => {
  const { t } = useTranslation('customsPass_consentBanner');
  const [isConsentAccepeted, setIsConsentAccepeted] = useState(Boolean(localStorage.getItem('isConsentAccepeted')));
  const handleClose = useCallback(() => {
    localStorage.setItem('isConsentAccepeted', 'true');
    setIsConsentAccepeted(true);
  }, []);

  if (isConsentAccepeted) {
    return null;
  }

  return (
    <Box sx={stylesConsentBannerContainer}>
      <Box component='span' sx={stylesConsentBannerHeaderTitle}>
        {t('customsPass.consentBanner.title')}
      </Box>

      <Box>{t('customsPass.consentBanner.content')}</Box>

      <Box sx={stylesConsentBannerActions}>
        <Button variant='contained' color='success' onClick={handleClose}>
          {t('customsPass.consentBanner.acceptButton')}
        </Button>
      </Box>
    </Box>
  );
};
